import { LOGISTICS_TYPES, OWNER_TYPES } from '~/constants/common';

import type { TypeTestAccount } from './types';

const VALID_OWNER_TYPES = new Set<string>(Object.values(OWNER_TYPES));
const VALID_LOGISTICS_TYPES = new Set<string>(Object.values(LOGISTICS_TYPES));

export const isValidAccount = (item: unknown): item is TypeTestAccount => {
  if (item === null || typeof item !== 'object') return false;
  const a = item as Record<string, unknown>;
  return (
    typeof a.loginId === 'string' &&
    typeof a.password === 'string' &&
    typeof a.ownerType === 'string' &&
    VALID_OWNER_TYPES.has(a.ownerType) &&
    Array.isArray(a.logisticsTypes) &&
    a.logisticsTypes.every((t) => typeof t === 'string' && VALID_LOGISTICS_TYPES.has(t))
  );
};

export const normalizeLoginId = (loginId: string): string => loginId.toLowerCase();

export const isSameLoginId = (a: string | null | undefined, b: string | null | undefined): boolean => {
  if (!a || !b) return false;
  return normalizeLoginId(a) === normalizeLoginId(b);
};
